import React from "react";
import { connect } from "react-redux";
import { Tooltip, Button, Modal } from "antd";
import documentListActions from "../store/actions/document-list.actions";
import { documentsActions } from "../store/actions/documents.actions";
import { declOfNum } from "../../../helpers/dspx-utils";

class DeleteDocuments extends React.Component {
	handleCkick = () => {
		const r = this.props.selectedDocuments.length;
		Modal.confirm({
			okText: "Да",
			title: `Удалить ${r} ${declOfNum(r, [
				" документ",
				" документа",
				" документов",
			])}?`,
			onOk: async () => {
				if (r > 10) {
					Modal.confirm({
						okText: "Подтверждаю",
						cancelText: "Отменить",
						okType: "danger",
						title: `Подтвердите удаление ${r} ${declOfNum(r, [
							" документа",
							" документов",
							" документов",
						])}?`,
						onOk: async () => {
							for (let b = 0; b < r; b += 1) {
								await this.props.dispatch(
									documentListActions.deleteDocument(
										this.props.selectedDocuments[b]
									)
								);
							}
							this.props.dispatch(documentsActions.fetchDocuments());
						},
						onCancel: () => {},
					});
				} else {
					for (let b = 0; b < r; b += 1) {
						await this.props.dispatch(
							documentListActions.deleteDocument(
								this.props.selectedDocuments[b]
							)
						);
					}
					this.props.dispatch(documentsActions.fetchDocuments());
				}
			},
			onCancel: () => {},
		});
	};

	render() {
		return (
			!!this.props.selectedDocuments.length && (
				<Tooltip
					title={
						"Удалить документы (" + this.props.selectedDocuments.length + ")"
					}
					placement="bottom"
				>
					<Button
						type="danger"
						shape="circle"
						icon="delete"
						style={{ marginRight: "10px" }}
						disabled={!this.props.selectedDocuments.length}
						onClick={this.handleCkick}
					/>
				</Tooltip>
			)
		);
	}
}

function mapStateToProps(state) {
	const { selectedDocuments } = state.documentListStore;
	return { selectedDocuments };
}

export default connect(mapStateToProps)(DeleteDocuments);
